import { FC, Fragment, useState, useEffect } from "react";

import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
} from "@mui/material";

import ExpandLess from "@mui/icons-material/ExpandLess";

import ExpandMore from "@mui/icons-material/ExpandMore";

import { useHistory } from "react-router-dom";

import { App } from "../../typings/App";

import { useAuth } from "oidc-react";

import { MenuItem } from "../Menu/MenuItem";

import { Submenu } from "../../typings/Submenu";

import { Item } from "../../typings/Item";

// Importar todas las imágenes de logos usando import.meta.glob de Vite
const logoModules = import.meta.glob('../../assets/appsLogos/*.png', { eager: true, import: 'default' }) as Record<string, string>;

interface Props {
  app: App;
  onCloseDrawer?: () => void;
  selectedItem?: string | null;
  onSelectItem?: (id: string) => void;
}

export const AppItem: FC<Props> = ({ app, onCloseDrawer, selectedItem, onSelectItem }) => {
  const auth = useAuth();

  const history = useHistory();

  const [isOpen, setIsOpen] = useState(false);

  // Obtener la imagen del logo usando import.meta.glob
  const imagePath = `../../assets/appsLogos/${app.iconUrl}.png`;
  const image = logoModules[imagePath] || '';

  const handleItemClick = () => {
    setIsOpen(!isOpen);

    if (!app.submenus || app.submenus.length === 0) {
      history.push(app.url);
    }
  };

  const handleSubitemClick = (item: Item) => {
    history.push(`${app.url}/${item.url}`);
    if (onSelectItem) {
      onSelectItem(item.url); // marcar como seleccionado
    }
    if (onCloseDrawer) {
      onCloseDrawer();
    }
  };

  const userRoles: string[] = (auth.userData?.profile["role"] as string[]) || [];

    // Filtrado simplificado según roles padre e hijos
  const filteredSubmenus: Submenu[] = app.submenus?.reduce<Submenu[]>(
    (acc, submenu) => {
      const hasParentRole = submenu.roles?.some(r => userRoles.includes(r));
      const children = submenu.items ?? [];

      // Si no tiene hijos y tiene rol padre, incluir
      if (children.length === 0) {
        if (hasParentRole) acc.push(submenu);
        return acc;
      }

      // Filtrar sólo hijos permitidos
      const allowedChildren = children.filter(item =>
        item.roles?.some(r => userRoles.includes(r))
      );

      if (hasParentRole) {
        // Incluye todo el submenu
        acc.push(submenu);
      } else if (allowedChildren.length > 0) {
        // Incluye submenu sólo con hijos permitidos
        acc.push({ ...submenu, items: allowedChildren });
      }

      return acc;
    },
    []
  ) ?? [];

  const handleAppItemClick = () => {
    handleItemClick();
    if (onSelectItem) {
      onSelectItem(app.url); // Usa un identificador único del app
    }
  };

  return (
    <Fragment>
      <ListItemButton onClick={handleAppItemClick}>
        <ListItemIcon>
          <Box
            component="img"
            alt={`logo ${app.visibleName}`}
            src={image}
            sx={{
              width: '90%',
              maxWidth: 50
            }}
          />
        </ListItemIcon>
        <ListItemText
          primary={app.visibleName}
          primaryTypographyProps={{
            style: { fontWeight: 900 },
          }}
          sx={{
            ml: 2,
            whiteSpace: 'nowrap'
          }}
        />
        {app.submenus &&
          app.submenus.length > 0 &&
          (isOpen ? (
            <ExpandLess sx={(theme) => ({ color: theme.palette.grey[600] })} />
          ) : (
            <ExpandMore sx={(theme) => ({ color: theme.palette.grey[600] })} />
          ))}
      </ListItemButton>

      <Collapse
        in={isOpen}
        timeout="auto"
        unmountOnExit
        sx={{ width: '100%' }}
      >
        <List component="div" disablePadding>
          {filteredSubmenus.map((submenu, idx) => (
            <MenuItem
              key={idx}
              submenu={submenu}
              handleSubitemClick={handleSubitemClick}
              selectedItem={selectedItem}
              onSelectItem={onSelectItem}
            />
          ))}
        </List>
      </Collapse>
    </Fragment>
  );
};
